import React, { useContext } from 'react'
import { graphql } from 'gatsby'
import queryString from 'query-string'

import { PageLayout, ProductList, PageBreadcrumb } from '../../components'
import Image from '../../components/Content/BlockHomePageHero/image'
import { l } from '../../lib/locale'
import { context } from '../../store'

const PF2023ActionTemplate = ({ data, pageContext }) => {
  const { store } = useContext(context)
  const { lang, page } = pageContext

  let items = null, items2 = null
  if (store && store.app && store.app.cartrules) {
    const rule = store.app.cartrules.find(i => i.display_code && i.display_code.toUpperCase() === "FROMME2023")
    items = data.allShopProduct.edges.filter(({ node }) => {
      return (rule && rule.items && rule.items.includes(+node.id_product))
    }).map(i => i.node)

    const rule2 = store.app.cartrules.find(i => i.display_code && i.display_code.toUpperCase() === "WEEKEND2023")
    items2 = data.allShopProduct.edges.filter(({ node }) => {
      return (rule2 && rule2.items && rule2.items.includes(+node.id_product))
    }).map(i => i.node)
  }

  const navigation = {
    page: 0
  }
  if (typeof window !== 'undefined') {
    const qs = queryString.parse(window.location.search)
    navigation.page = qs.page ? +qs.page : 0
  }

  return (
    <PageLayout lang={lang} switcher={page}>
      <div className="product-list-4 product-list-breadcrumbs">
        <PageBreadcrumb
          lang={lang}
          current={page}
          items={[ 'homepage' ]}
          />
        <div className="col-12">
          <Image className="hero-image" alt={l('block-hero-title', lang)} lang={lang} />
        </div>
        <ProductList
          header={(<p dangerouslySetInnerHTML={{ __html: l('action-fromme2023-intro', lang) }} />)}
          products={items}
          attributes={data.allShopAttribute.edges.map(i => i.node)}
          attribute_groups={data.allShopAttributeGroup.edges.map(i => i.node)}
          lang={lang}
          navigation={navigation}
          keyPrefix="pf2023" />
        <ProductList
          header={(<p dangerouslySetInnerHTML={{ __html: l('action-weekend2023-intro', lang) }} />)}
          products={items2}
          attributes={data.allShopAttribute.edges.map(i => i.node)}
          attribute_groups={data.allShopAttributeGroup.edges.map(i => i.node)}
          lang={lang}
          navigation={navigation}
          keyPrefix="wk2023" />
      </div>
    </PageLayout>
  )
}

export default PF2023ActionTemplate

export const query = graphql`
  query PF2023ActionTemplateQuery {
    allShopProduct {
      edges {
        node {
          ...ProductSearchItem
        }
      }
    }
    allShopAttributeGroup {
      edges {
        node {
          group_type
          id_attribute_group
          is_color_group
          name_en
          name_nl
          position
          public_name_en
          public_name_nl
        }
      }
    }
    allShopAttribute {
      edges {
        node {
          id_attribute
          id_attribute_group
          color
          name_en
          name_nl
          position
        }
      }
    }
  }
`
